// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1vZ_I","title":"Header_title__3fv1E","side":"Header_side__1Eg4h"};